import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { AxiosError } from 'axios';
import 'react-toastify/dist/ReactToastify.css';
import Header from '../../components/Header';
import Container from '../../components/Container';
import { api } from '../../services/api';
import { Loading } from '../../components/Loading';
import svg from '../../static/img/account-management.svg';
import Status from '../../components/Status';

const ConfirmChangeEmailContainer = styled.div`
  height: 55.7vh;
  display: flex;
  justify-content: center;
  margin-top: 30px;
  font-size: 16px;
  svg {
    display: inline;
  }

  @media (max-width: 650px) {
    width: 95%;
  }
`;

interface ParamsUserData {
  name: string;
  email: string;
}

const ConfirmChangeEmailPage = () => {
  const [statusRequest, setStatusRequest] = useState<string>('');
  const [paramsUserData, setParamsUserData] = useState<ParamsUserData>({
    name: '',
    email: '',
  });

  const confirmChangeEmailRequest = (otp: string) => {
    const body = {
      otp,
    };
    setStatusRequest('wait');
    api
      .put('/email/confirm', body, {
        headers: { 'Content-Type': 'application/json' },
      })
      .then(() => {
        setStatusRequest('success');
      })
      .catch((error: AxiosError) => {
        switch (error.response?.status) {
          case 406:
            setStatusRequest('retry');
            break;
          case 409:
            setStatusRequest('alreadyExists');
            break;
          default:
            setStatusRequest('error');
            break;
        }
      });
  };

  const Success: React.FC = () => {
    return (
      <Status
        icon={`${svg}#icon-check`}
        title=" E-mail alterado com sucesso!"
        colorTitle="#0669de"
      >
        <p>
          Olá, <b>{paramsUserData.name}</b>.
        </p>
        <p>
          Sua solicitação foi realizada e o e-mail <b>{paramsUserData.email}</b>{' '}
          já se encontra ativo.
        </p>
      </Status>
    );
  };

  const Retry: React.FC = () => {
    return (
      <Status
        icon={`${svg}#icon-check-failed`}
        title="Por favor tente novamente!"
        colorTitle="#FE0000"
      />
    );
  };

  const AlreadyExists: React.FC = () => {
    return (
      <Status
        icon={`${svg}#icon-check-failed`}
        title="E-mail já registrado, por favor tente um novo e-mail!"
        colorTitle="#FE0000"
      />
    );
  };

  const Error: React.FC = () => {
    return (
      <Status
        icon={`${svg}#icon-check-failed`}
        title="Falha na ativação do email!"
        colorTitle="#FE0000"
      />
    );
  };

  const renderWithStatusResponse = () => {
    switch (statusRequest) {
      case 'wait':
        return <Loading />;
      case 'success':
        return <Success />;
      case 'retry':
        return <Retry />;
      case 'alreadyExists':
        return <AlreadyExists />;
      case 'error':
        return <Error />;
      default:
        return '';
    }
  };

  useEffect(() => {
    let isMounted = true;
    const paramsURL = new URLSearchParams(window.location.hash.substring(7));
    const otp = paramsURL.get('otp');
    const name = paramsURL.get('name');
    const email = paramsURL.get('email');

    setParamsUserData({
      name: name || '',
      email: email || '',
    });

    if (isMounted) {
      if (otp) {
        confirmChangeEmailRequest(otp);
      } else {
        setStatusRequest('error');
      }
    }
    return () => {
      isMounted = false;
    };
  }, []);

  if (statusRequest === 'wait') {
    return <Loading />;
  }

  return (
    <>
      <Header />
      <Container>
        <ConfirmChangeEmailContainer>
          {renderWithStatusResponse()}
        </ConfirmChangeEmailContainer>
      </Container>
    </>
  );
};

export default ConfirmChangeEmailPage;
